var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7682 1.16422L7.04484 14.4084L3.40318 10.5176C2.73234 9.88505 1.67818 9.84672 0.91151 10.3834C0.16401 10.9392 -0.0468241 11.9167 0.413176 12.7026L4.72568 19.7176C5.14734 20.3692 5.87568 20.7717 6.69984 20.7717C7.48568 20.7717 8.23318 20.3692 8.65484 19.7176C9.34484 18.8167 22.5123 3.11922 22.5123 3.11922C24.2373 1.35588 22.1482 -0.196615 20.7682 1.14505V1.16422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.32f90b0bf0d3794c51d5a755272be47a.svg";
export { ForwardRef as ReactComponent };